<template>
    <div class="body v2-list-page">
        <div class="order-page-container">
            <div class="page-section">
                <a-card :bordered="false" style="width: 100%" class="v2-page-card">
                    <template slot="title">
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <router-link to="/cliente/monitores/cotacoes">
                                    Home
                                </router-link>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item class="order-page-title">
                                Produtos
                            </a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>
                    <PageTabs :tabs="tabs" :active="activeTab" @change="openTab" />
                </a-card>
            </div>

            <div class="v2-tab-content">
                <MyProductsV2Tab
                    v-if="visitedTabs.includes('MY_PRODUCTS')"
                    v-show="activeTab === 'MY_PRODUCTS'"
                    @count="(value) => (counts.MY_PRODUCTS = value)"
                />
                <PriceTrackingV2Tab
                    v-if="visitedTabs.includes('PRICE_TRACKING')"
                    v-show="activeTab === 'PRICE_TRACKING'"
                    @count="(value) => (counts.PRICE_TRACKING = value)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import PageTabs from "@/components/cliente/monitors/PageTabs.vue";
import MyProductsV2Tab from "./tabs/my-products-v2.tab.vue";
import PriceTrackingV2Tab from "./tabs/price-tracking-v2.tab.vue";

const TAB_KEYS = ["MY_PRODUCTS", "PRICE_TRACKING"];

const tabFromQuery = (query) => (TAB_KEYS.includes(query.tab) ? query.tab : "MY_PRODUCTS");

export default {
    name: "ProductsV2Page",
    components: { PageTabs, MyProductsV2Tab, PriceTrackingV2Tab },
    data() {
        const activeTab = tabFromQuery(this.$route.query);
        return {
            activeTab,
            visitedTabs: [activeTab],
            counts: { MY_PRODUCTS: 0, PRICE_TRACKING: 0 },
        };
    },
    computed: {
        tabs() {
            return [
                { key: "MY_PRODUCTS", label: "Meus Produtos", icon: "inventory_2", badge: this.formatCount(this.counts.MY_PRODUCTS) },
                { key: "PRICE_TRACKING", label: "Acompanhamento de preços", icon: "query_stats", badge: this.formatCount(this.counts.PRICE_TRACKING) },
            ];
        },
    },
    watch: {
        "$route.query.tab"() {
            this.activate(tabFromQuery(this.$route.query));
        },
    },
    mounted() {
        this.$store.dispatch("set_breadcrumbs", [{ name: "Produtos", route: "products-v2" }]);
    },
    methods: {
        formatCount(value) {
            return value ? Number(value).toLocaleString("pt-BR") : undefined;
        },
        activate(key) {
            this.activeTab = key;
            if (!this.visitedTabs.includes(key)) this.visitedTabs.push(key);
        },
        openTab(key) {
            this.activate(key);
            if (this.$route.query.tab !== key) {
                this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(() => {});
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_list-page-v2";
</style>
